import { observer } from 'mobx-react';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { RadioButton } from 'primereact/radiobutton';
import { Tree, TreeCheckboxSelectionKeys } from 'primereact/tree';
import useAddIterationLogic from './AddIteration.logic';
import { checkIfFunctionalityEnabled } from 'utils/facts/roleBasedFunctionalityAccess';
import { bdTrackerAllowedRoles } from 'data/bdTracker/bdTrackerUserRoleValidations';

const AddIterationModal = ({
  visibility,
  handleClose,
  opportunityID,
  opportunityIterationID,
  board,
}: {
  visibility: boolean;
  handleClose: (newIterationCreated?: boolean) => void;
  opportunityID: number;
  opportunityIterationID: number;
  board: string;
}) => {
  const {
    userModulesRoles,
    nodes,
    selectedKeys,
    setBoardType,
    isIterationLoading,
    boardType,
    handleAddButtonClick,
    selectAllOptions,
    unselectAllOptions,
    checkIfAllSelected,
    handleSelectionChange,
  } = useAddIterationLogic(visibility, handleClose, opportunityID, opportunityIterationID, board);

  return (
    <Dialog
      blockScroll
      resizable={false}
      header={`Add New Iteration`}
      visible={visibility}
      style={{ width: '50vw' }}
      onHide={() => {
        if (!visibility) return;
        handleClose();
      }}
      draggable={false}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: '1rem',
          maxHeight: '70vh',
          overflow: 'scroll',
        }}
      >
        <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
          <div
            onClick={() => (checkIfAllSelected() ? unselectAllOptions() : selectAllOptions())}
            style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}
          >
            <RadioButton inputId="opportunityType2" checked={checkIfAllSelected()} />
            <label htmlFor="opportunityType2" className="ml-2">
              {checkIfAllSelected() ? `Unselect All` : `Select All`}
            </label>
          </div>
        </div>
        <Tree
          value={nodes}
          selectionKeys={selectedKeys}
          selectionMode="checkbox"
          onSelectionChange={e => handleSelectionChange(e.value as TreeCheckboxSelectionKeys)}
          className="w-full md:w-30rem"
        />
        <div
          style={{
            display: 'flex',
            gap: '1rem',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '1rem  0.5rem',
          }}
        >
          <div style={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
            <div>Opportunity Type :</div>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              <RadioButton
                inputId="opportunityType1"
                name="MAS"
                value="MAS"
                onChange={e => setBoardType(e.value)}
                checked={boardType === 'MAS'}
              />
              <label htmlFor="opportunityType1" className="ml-2">
                MAS
              </label>
            </div>
            <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
              <RadioButton
                inputId="opportunityType2"
                name="NC"
                value="NC"
                onChange={e => setBoardType(e.value)}
                checked={boardType === 'NC'}
              />
              <label htmlFor="opportunityType2" className="ml-2">
                NC
              </label>
            </div>
          </div>

          <Button
            label="Add Iteration"
            style={{
              backgroundColor: '#522D6E',
              marginLeft: '1rem',
              alignSelf: 'flex-end',
              border: '1px solid #522D6E',
              fontSize: '0.8rem',
              padding: '0.5rem 0.75rem',
            }}
            loading={isIterationLoading}
            disabled={
              !checkIfFunctionalityEnabled(
                bdTrackerAllowedRoles.createNewIterationButton,
                userModulesRoles.opptracker,
                userModulesRoles
              )
            }
            onClick={handleAddButtonClick}
          />
        </div>
      </div>
    </Dialog>
  );
};

export default observer(AddIterationModal);
